import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import MapIcon from "@mui/icons-material/Map";
import SendIcon from "@mui/icons-material/Send";
import Skeleton from "@mui/material/Skeleton";
import ImageWithFallback from "components/common/ImageWithFallback";
import { useEffect } from "react";
import {
  fetchProfileEvents,
  selectProfileEvents,
} from "store/event/profileEvents.slice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  EventUpcomingHeader,
  ProfileEventsContainer,
  ProfileUpcomingEvents,
} from "../Events/Events.styles";
import {
  ProfileBottomContainer,
  ProfileButton,
  ProfileEventContainer,
  ProfileEventImage,
  ProfileEventInfo,
  ProfileEventInfoContent,
  ProfileEventLocation,
  ProfileEventName,
  ProfileEventTime,
} from "./Events.styles";
import NoEventsPlaceholder from "./TabEvents/NoEventsPlaceholder";

export default function ProfileEvents() {
  const dispatch = useAppDispatch();
  const { events, totalPages, currentPage, isLoading, error } =
    useAppSelector(selectProfileEvents);

  useEffect(() => {
    dispatch(fetchProfileEvents(1));
  }, [dispatch]);

  function handleNextPage() {
    if (!isLoading && currentPage < totalPages) {
      dispatch(fetchProfileEvents(currentPage + 1));
    }
  }

  return (
    <ProfileUpcomingEvents style={{ position: "relative" }}>
      <EventUpcomingHeader>
        <h2>Upcoming Events</h2>
        {/* <a href="/org/events" className="see-all">
          See all events
        </a> */}
      </EventUpcomingHeader>
      {isLoading && (
        <ProfileEventsContainer>
          {[...Array(3)].map((_, idx) => (
            <ProfileEventContainer key={idx}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={130}
                animation="wave"
                sx={{ borderRadius: "10px 10px 0 0" }}
              />

              <ProfileEventInfo style={{ width: "100%" }}>
                <Skeleton
                  variant="text"
                  width="70%"
                  height={22}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width="60%"
                  height={16}
                  animation="wave"
                />
              </ProfileEventInfo>

              <ProfileBottomContainer>
                <Skeleton
                  variant="rectangular"
                  width={100}
                  height={34}
                  animation="wave"
                  sx={{ borderRadius: "4px" }}
                />
                <Skeleton
                  variant="circular"
                  width={20}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  variant="circular"
                  width={20}
                  height={20}
                  animation="wave"
                />
              </ProfileBottomContainer>
            </ProfileEventContainer>
          ))}
        </ProfileEventsContainer>
      )}

      {!isLoading && (error || events.length === 0) && (
        <NoEventsPlaceholder message={"You have no upcoming events planned"} />
      )}
      {!isLoading && !error && events.length > 0 && (
        <ProfileEventsContainer>
          {events.map((event) => (
            <ProfileEventContainer key={event.id}>
              <ProfileEventImage>
                <ImageWithFallback
                  src={event.visuals?.[0]?.image_url}
                  alt={event.activity_title}
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
                />
              </ProfileEventImage>
              <ProfileEventInfo>
                <ProfileEventName>{event.activity_title}</ProfileEventName>
                <ProfileEventInfoContent>
                  <AccessTimeIcon
                    style={{ color: "#757575", width: "13px", height: "13px" }}
                  />
                  <ProfileEventTime>
                    {new Date(event.start_date_time).toLocaleString()}
                  </ProfileEventTime>
                </ProfileEventInfoContent>
                {event.places.length > 0 && (
                  <ProfileEventLocation>
                    <MapIcon
                      style={{
                        color: "#757575",
                        width: "13px",
                        height: "13px",
                      }}
                    />
                    {event.places[0].place_city
                      ? `${event.places[0].place_city}, `
                      : ""}
                    {event.places[0].place_state ?? ""}
                  </ProfileEventLocation>
                )}
              </ProfileEventInfo>
              <ProfileBottomContainer>
                <ProfileButton>Register</ProfileButton>
                <FavoriteBorderIcon style={{ width: "18px", height: "18px" }} />
                <SendIcon style={{ width: "18px", height: "18px" }} />
              </ProfileBottomContainer>
            </ProfileEventContainer>
          ))}
        </ProfileEventsContainer>
      )}
      {/* <button
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: "20px",
          cursor: "pointer",
        }}
        onClick={handleNextPage}
        disabled={isLoading || currentPage >= totalPages}
      >
        &gt;
      </button> */}
    </ProfileUpcomingEvents>
  );
}
